import { Box, Flex, Text } from "@shared/primitive-components"
import { PropsWithChildren } from "react"
import { Property } from "csstype"

import * as styles from "./styles/legendStyles"

export type ChartLegendItemProps = {
  label?: string
  color?: Property.Color
}

export const ChartLegend = ({ children }: PropsWithChildren<{}>) => (
  <Flex alignItems="center" justifyContent="end" css={styles.legendContainer}>
    {children}
  </Flex>
)

export const ChartLegendItem = ({ label, color }: ChartLegendItemProps) =>
  color && label ? (
    <Flex alignItems="center" css={styles.item}>
      <Text css={styles.label}>{label}</Text>
      <Box css={styles.symbol(color)} />
    </Flex>
  ) : null

ChartLegendItem.defaultProps = {
  label: undefined,
  color: undefined,
}
